import config, { baseApiUrl } from 'config';
import { fetchData } from 'framework/api/fetch-data';
import { AuthorizationClaims, ensureClaims } from 'framework/authorization';
import { FeatureState } from './types';

export const isBusinessAccountMultipleStoresEnabled = async (): Promise<FeatureState> => {
  const userHasAccess = ensureClaims(AuthorizationClaims.CUSTOMER_BUSINESS_ACCOUNTS);

  if (!userHasAccess || !baseApiUrl) {
    return {
      isEnabled: false,
    };
  }

  const result = await fetchData({
    url: `${config.apiEndpoints.featureFlags}/MultiBusinessAccountsEnabled`,
    method: 'HEAD',
  });

  return {
    isEnabled: result.status === 200,
  };
};
